export default __webpack_public_path__ + "static/media/logo-text-white.ec42c34f.svg";